<div class="admin-modal">
  <h2 class="title">Confirm consultation meeting</h2>
  <p class="subtitle">{{ data.booking.userFullName }} · {{ data.booking.slotStartAt | date:'EEE d MMM, HH:mm' }}</p>

  <label class="field">
    <span>Meeting link <em>*</em></span>
    <input type="url" name="meetingLink" [(ngModel)]="meetingLink"
           placeholder="https://meet.google.com/…" />
  </label>

  <label class="field">
    <span>Notes (optional)</span>
    <textarea name="notes" rows="3" [(ngModel)]="notes"
              placeholder="Anything the candidate should know…"></textarea>
  </label>

  <div class="actions">
    <button type="button" class="btn ghost" (click)="close()">Cancel</button>
    <button type="button" class="btn primary" [disabled]="!isValid" (click)="submit()">Confirm meeting</button>
  </div>
</div>
